import api from '@tyrio/api-factory';
import { DBStockCountApi, DBStockCountRecountReq } from '@tyrio/dto';
import { ToastHelper, ToastMessageType, ToastType } from '@tyrio/ui-library';
import { useMutation } from 'react-query';
import { queryClient } from '../../../../../../src/app/query-client';

export const useRecountStockCount = () => {
  const mutation = useMutation(
    (req: DBStockCountRecountReq) =>
      api.fetch<DBStockCountApi['recount']>('recount_stock_count', {
        ...req,
      }),
    {
      mutationKey: 'recount_stock_count',
      onSuccess: () => {
        queryClient.invalidateQueries('get_stock_counts');
        queryClient.invalidateQueries('count_stock_count_status');

        ToastHelper.showToast(
          'Success',
          ToastType.SUCCESS,
          ToastMessageType.CREATE
        );
      },
    }
  );

  return { ...mutation };
};
